module.exports = __webpack_public_path__ + "img/logo.2311544f.png";